import React from 'react';
import { SlideLogo } from '../components/canvas/SlideLogo';
import { SlideContent } from '../components/canvas/SlideContent';
import { SlideFooter } from '../components/canvas/SlideFooter';
import { NudgeableGroup } from '../components/canvas/NudgeableGroup';

/**
 * Split layout — professional, asymmetric.
 * Left half has a semi-transparent dark panel with content.
 * Right half is pure background.
 * Footer pinned at bottom for cross-template consistency.
 */
export function SplitLayout({ data, fontPreset, logoEnabled = true, logoUrl = null, logoSize = null, logoIsDark = false, pc }) {
  return (
    <div className="absolute inset-0 flex">
      {/* Left panel */}
      <div
        className="relative w-[55%] h-full flex flex-col"
        style={{ backgroundColor: pc.surfaceAt(0.55) }}
      >
        {/* Logo */}
        {logoEnabled && (
          <NudgeableGroup groupId="logo" className="px-[56px] pt-[64px]">
            <SlideLogo className="h-14 w-14" style={{ color: pc.text(0.70) }} logoUrl={logoUrl} size={logoSize} isDark={logoIsDark} />
          </NudgeableGroup>
        )}

        {/* Content */}
        <NudgeableGroup groupId="content" className="flex-1 flex flex-col justify-center px-[56px] pb-[140px]">
          <SlideContent
            data={data}
            fontPreset={fontPreset}
            pc={pc}
            options={{
              showFooter: false,
              mutedOpacity: 0.65,
              subtleOpacity: 0.45,
            }}
          />
        </NudgeableGroup>
      </div>

      {/* Right side — pure background */}
      <div className="flex-1" />

      {/* Footer — pinned at bottom, spans full width */}
      <div className="absolute bottom-[64px] left-[64px] right-[64px]">
        <SlideFooter data={data} pc={pc} />
      </div>
    </div>
  );
}
